<template>
  <div class="container mt-3">
    <div class="row">
      <div class="col s12">
        <div class="card">
          <div class="card-title primary white-text">
            <i class="material-icons icon">home</i>
            Address List
            <a @click="openNewDialog" class="btn btn-small waves-effect waves-light green right"><i class="material-icons left mr-1">add</i> Add new</a>
          </div>

          <div class="card-content">
            <div class="mb-3">
              Here is the list of delivery addresses in your account.
              You can add, edit, delete and set your default shipping address.<br>
            </div>

            <div class="row mb-0">
              <div v-if="loadingList" class="progress">
                <div class="indeterminate"></div>
              </div>

              <div class="col s12 m6 l4"
                v-for="item in addressList"
                :key="item.id"
              >
                <div class="card">
                  <div class="card-title blue-grey lighten-5">
                    <a @click="openEditDialog(item)">{{ item.childName }}</a>
                  </div>

                  <div class="card-content">
                    <div class="row">
                      <div class="col s12">
                        <i class="primary-text">Address:</i><br>
                        C/o {{ item.name }}<br>
                        {{ item.address }}<br>
                        {{ item.landmark }}<br>
                        {{ item.city }},
                        {{ item.state }}<br>
                        {{ item.country }}
                        {{ item.pincode }}
                      </div>

                      <div class="col s12">
                        <i class="primary-text">Phones:</i><br>
                        {{ item.phone1 ? item.phone1 : '--' }}
                        {{ item.phone2 ? (item.phone1 ? ' / ' : '') + item.phone2 : '' }}
                      </div>
                    </div>
                  </div>

                  <div class="card-action">
                    <a
                      class="waves-effect waves-light btn btn-small mb-1"
                      :disabled="(item.ship_default === '1') ? true : false"
                      @click="updateShippingDefault(item)"
                    >
                      {{ (item.ship_default === '1') ? 'Default' : 'Set as Default' }}
                    </a>

                    <div class="right">
                      <a
                        class="waves-effect waves-light btn btn-small btn-flat btn-floating mr-1 mb-1 green"
                        @click="openEditDialog(item)"
                      >
                        <i class="material-icons left mr-1">edit</i>
                      </a>

                      <a
                        class="waves-effect waves-light btn btn-small btn-flat btn-floating mb-1 red lighten-2"
                        @click="deleteItem(item)"
                      >
                        <i class="material-icons left mr-1">delete</i>
                      </a>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            id="editModal"
            class="modal"
          >
            <div class="card mt-0 mb-0">
              <div class="card-title blue-grey lighten-5">
                <i class="material-icons icon">home</i>
                {{ formTitle }}
              </div>

              <div class="card-content">
                <div class="row">
                  <div class="input-field col s12">
                    <input
                      autofocus
                      type="text"
                      id="childName"
                      v-model="editedItem.childName"
                    >
                    <label for="childName">Child's Name</label>
                    <span class="helper-text red-text">{{ (formErrors.childName !== '') ? formErrors.childName : '' }}</span>
                  </div>

                  <div class="input-field col s12">
                    <input
                      type="text"
                      class="datepicker"
                      id="dateOfBirth"
                      v-model.lazy="editedItem.dateOfBirth"
                    >
                    <label for="dateOfBirth">Child's Date of Birth</label>
                    <span class="helper-text red-text">{{ (formErrors.dateOfBirth !== '') ? formErrors.dateOfBirth : '' }}</span>
                  </div>

                  <div class="input-field col s12">
                    <input
                      type="text"
                      id="name"
                      v-model="editedItem.name"
                    >
                    <label for="name">Your Name</label>
                    <span class="helper-text">Parent's/Adult's name</span>
                    <span class="helper-text red-text">{{ (formErrors.name !== '') ? formErrors.name : '' }}</span>
                  </div>

                  <div class="input-field col s12">
                    <textarea
                      id="address"
                      v-model="editedItem.address"
                      class="materialize-textarea"
                    ></textarea>
                    <label for="address">Address</label>
                    <span class="helper-text red-text">{{ (formErrors.address !== '') ? formErrors.address : 'House / Flat no, Locality' }}</span>
                  </div>

                  <div class="input-field col s12">
                    <input
                      type="text"
                      id="landmark"
                      v-model="editedItem.landmark"
                    >
                    <label for="landmark">Landmark</label>
                    <span class="helper-text red-text">{{ (formErrors.landmark !== '') ? formErrors.landmark : '' }}</span>
                  </div>

                  <div class="input-field col s12 m6">
                    <select id="city" v-model="editedItem.shippingLocationID">
                      <option value="1" selected>Indore</option>
                      <option value="2">Other</option>
                    </select>
                    <label for="city">Select delivery city</label>
                    <span class="helper-text red-text">{{ (formErrors.shippingLocationID !== '') ? formErrors.shippingLocationID : '' }}</span>
                  </div>

                  <div v-show="editedItem.shippingLocationID === '2'" class="input-field col s12 m6">
                    <input
                      type="text"
                      id="city"
                      v-model="editedItem.city"
                    >
                    <label for="city">City</label>
                    <span class="helper-text red-text">{{ (formErrors.city !== '') ? formErrors.city : '' }}</span>
                  </div>
                  <div class="clearfix"></div>

                  <div class="input-field col s12 m6">
                    <input
                      type="text"
                      id="pincode"
                      v-model="editedItem.pincode"
                    >
                    <label for="pincode">Postal Code</label>
                    <span class="helper-text red-text">{{ (formErrors.pincode !== '') ? formErrors.pincode : '' }}</span>
                  </div>

                  <div class="input-field col s12 m6">
                    <input
                      type="text"
                      id="state"
                      v-model="editedItem.state"
                    >
                    <label for="state">State</label>
                    <span class="helper-text red-text">{{ (formErrors.state !== '') ? formErrors.state : '' }}</span>
                  </div>

                  <div class="input-field col s12 m6">
                    <input
                      type="text"
                      id="country"
                      v-model="editedItem.country"
                      readonly
                    >
                    <span class="suffix" style="top:0.2rem;">
                      <i class="material-icons grey-text text-lighten-1" style="font-size:1.5rem;">lock</i>
                    </span>
                    <label for="country">Country</label>
                    <span class="helper-text red-text">{{ (formErrors.country !== '') ? formErrors.country : '' }}</span>
                  </div>
                  <div class="clearfix"></div>

                  <div class="input-field col s12 m6">
                    <input
                      type="text"
                      id="phone1"
                      v-model="editedItem.phone1"
                    >
                    <label for="phone1">Phone 1</label>
                    <span class="helper-text red-text">{{ (formErrors.phone1 !== '') ? formErrors.phone1 : '' }}</span>
                  </div>

                  <div class="input-field col s12 m6">
                    <input
                      type="text"
                      id="phone2"
                      v-model="editedItem.phone2"
                    >
                    <label for="phone2">Phone 2</label>
                    <span class="helper-text red-text">{{ (formErrors.phone2 !== '') ? formErrors.phone2 : '' }}</span>
                  </div>
                </div>
              </div>

              <div class="card-action">
                <a
                  class="waves-effect waves-light btn grey lighten-3 black-text"
                  @click="closeDialogEdit"
                >
                  Cancel
                </a>

                <a
                  class="waves-effect waves-light btn success right"
                  :disabled="saveInProgress"
                  @click="saveForm"
                >
                  <div v-if="saveInProgress" class="saving-animation">
                    <div class="lds-ripple">
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                  <i v-if="!saveInProgress" class="material-icons left">check</i>
                  Save
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.defaultShipping label {
  font-size: 13px;
}
</style>

<script>
// Import the API functions
import httpApi from '@/utils/api'

// Date formatting helper
import format from 'date-fns/format'
import parse from 'date-fns/parse'

export default {
  data () {
    return {
      // Variable to save address list
      addressList: [],

      // Loading status for list of items
      loadingList: true,

      // Error message when loading error or no items returned
      errorList: '',

      /**
       * Items for dialog form
       */
      // Dialog active?
      dialogEdit: null,
      saveInProgress: false,

      // The index of the item being edited
      editedIndex: -1,

      // Form bound variables being edited
      editedItem: {
        id: 0,
        childName: '',
        dateOfBirth: '',
        name: '',
        address: '',
        landmark: '',
        city: '',
        shippingLocationID: '1',
        state: '',
        country: 'India',
        pincode: '',
        phone1: '',
        phone2: ''
      },

      // Default items used to reset the form
      defaultItem: {
        id: 0,
        childName: '',
        dateOfBirth: '',
        name: '',
        address: '',
        landmark: '',
        city: '',
        shippingLocationID: '1',
        state: '',
        country: 'India',
        pincode: '',
        phone1: '',
        phone2: ''
      },

      // Error holders for form fields
      formErrors: {
        childName: null,
        dateOfBirth: null,
        name: null,
        address: null,
        landmark: null,
        city: null,
        shippingLocationID: null,
        state: null,
        country: null,
        pincode: null,
        phone1: null,
        phone2: null
      },

      // Default error holders used to reset the form
      defaultFormErrors: {
        childName: null,
        dateOfBirth: null,
        name: null,
        address: null,
        landmark: null,
        city: null,
        shippingLocationID: null,
        state: null,
        country: null,
        pincode: null,
        phone1: null,
        phone2: null
      }
    }
  },

  computed: {
    // Show a different form title if new or editing
    formTitle () {
      return this.editedIndex === -1 ? 'New Address' : 'Edit Address'
    }
  },

  mounted () {
    // On load, get data from API and populate table
    this.getAddressListFromApi()
      .then(data => {
        this.assignFetchedList(data)

        var elems1 = document.querySelectorAll('.modal')
        // eslint-disable-next-line
        var instances1 = M.Modal.init(elems1)
        // eslint-disable-next-line
        this.dialogEdit = M.Modal.getInstance(document.getElementById('editModal'))

        var elems2 = document.querySelectorAll('.datepicker')
        // eslint-disable-next-line
        var maxDate = new Date()
        // eslint-disable-next-line
        var instances2 = M.Datepicker.init(elems2, {
          // Datepicker within a modal looks wrong, if not placed on body
          container: 'body',
          format: 'dd mmm yyyy',
          maxDate: maxDate,
          // 25+ year olds are not kids, right?
          yearRange: [(maxDate.getFullYear() - 25), maxDate.getFullYear()]
        })

        var elems3 = document.querySelectorAll('select')
        // eslint-disable-next-line
        var instances3 = M.FormSelect.init(elems3, {
          dropdownOptions: {
            coverTrigger: false
          }
        })
      })
      .catch((err) => {
        this.errorList = err.message
      })
  },

  methods: {
    // Wrapper for the API call
    getAddressListFromApi () {
      // Activate loading animation
      this.loadingList = true

      // Promise a return
      return new Promise((resolve, reject) => {
        // Make the API call
        httpApi.callWithToken({
          url: 'address',
          method: 'get'
        })
          .then((resp) => {
            // Deactivate the loading animation
            this.loadingList = false

            // Resolve the promise
            resolve({
              // List of items
              items: resp.data.items
            })
          })
          // If an error occurs
          .catch((err) => {
            // Deactivate the loading animation
            this.loadingList = false

            // Broken promise
            reject(err)
          })
      })
    },

    // API data is assigned to multiple variables
    assignFetchedList (data) {
      this.addressList = data.items

      this.addressList.forEach((value, key) => {
        this.addressList[key].shippingLocationID = value.shippingLocationID.toString()
        this.addressList[key].rawDateOfBirth = parse(value.dateOfBirth)
        this.addressList[key].dateOfBirth = format(parse(value.dateOfBirth), 'DD MMM YYYY')
      })

      this.errorList = (data.total === 0) ? 'No addresses found' : ''
    },

    // Add or edit an address
    saveForm () {
      this.saveInProgress = true

      // Is an existing item being edited?
      if (this.editedIndex > -1) {
        this.editedItem.city = this.editedItem.shippingLocationID === '1' ? 'Indore' : this.editedItem.city

        let dataBody = {
          addressID: this.editedItem.id,
          childName: this.editedItem.childName,
          dateOfBirth: this.editedItem.dateOfBirth,
          name: this.editedItem.name,
          address: this.editedItem.address,
          landmark: this.editedItem.landmark,
          city: this.editedItem.city,
          deliveryCity: this.editedItem.shippingLocationID,
          state: this.editedItem.state,
          country: this.editedItem.country,
          pincode: this.editedItem.pincode,
          phone1: this.editedItem.phone1,
          phone2: this.editedItem.phone2
        }

        // Save to API
        httpApi.callWithToken({
          url: 'address',
          data: dataBody,
          method: 'put'
        })
          .then((resp) => {
            // Show success message
            this.$store.dispatch('SHOW_STATUS_MESSAGE', {
              color: 'success',
              message: resp.message
            })

            // Update edited item to main list
            Object.assign(this.addressList[this.editedIndex], this.editedItem)

            // Close and reset dialog
            this.closeDialogEdit()

            this.saveInProgress = false
          })
          .catch((err) => {
            this.saveInProgress = false

            // Empty older errors
            this.formErrors = Object.assign({}, this.defaultFormErrors)

            // Show new errors. Timeout required, else fails
            setTimeout(() => {
              let errors = Object.keys(err.data)
              errors.forEach((value, key) => {
                // Set field's error message
                this.formErrors[value] = err.data[value]
              })
            }, 100)

            // There could be multiple errors in an array. Convert to a string
            let errorString = Object.values(err.data)
            errorString = errorString.join(', ')

            // Show error message
            this.$store.dispatch('SHOW_STATUS_MESSAGE', {
              color: 'error',
              message: errorString
            })
          })

      // Or is a new item being added?
      } else {
        this.editedItem.city = this.editedItem.shippingLocationID === '1' ? 'Indore' : this.editedItem.city

        // Create API data body
        let dataBody = {
          childName: this.editedItem.childName,
          dateOfBirth: this.editedItem.dateOfBirth,
          name: this.editedItem.name,
          address: this.editedItem.address,
          landmark: this.editedItem.landmark,
          city: this.editedItem.city,
          deliveryCity: this.editedItem.shippingLocationID,
          state: this.editedItem.state,
          country: this.editedItem.country,
          pincode: this.editedItem.pincode,
          phone1: this.editedItem.phone1,
          phone2: this.editedItem.phone2
        }

        // Save to API
        httpApi.callWithToken({
          url: 'address',
          data: dataBody,
          method: 'post'
        })
          .then((resp) => {
            // Show success message
            this.$store.dispatch('SHOW_STATUS_MESSAGE', {
              color: 'success',
              message: resp.message
            })

            // Update list with new code
            this.editedItem.id = resp.data.addressID
            this.editedItem.ship_default = resp.data.ship_default.toString()

            // Add new item to main list
            this.addressList.push(this.editedItem)

            // Close and reset dialog
            this.closeDialogEdit()

            this.saveInProgress = false
          })
          .catch((err) => {
            this.saveInProgress = false

            // Empty older errors
            this.formErrors = Object.assign({}, this.defaultFormErrors)

            // Show new errors. Timeout required, else fails
            setTimeout(() => {
              let errors = Object.keys(err.data)
              errors.forEach((value, key) => {
                // Set field's error message
                this.formErrors[value] = err.data[value]
              })
            }, 100)

            // There could be multiple errors in an array. Convert to a string
            let errorString = Object.values(err.data)
            errorString = errorString.join(', ')

            // Show error message
            this.$store.dispatch('SHOW_STATUS_MESSAGE', {
              color: 'error',
              message: errorString
            })
          })
      }
    },

    // Setup the new dialog
    openNewDialog () {
      // Set default formErrors
      this.formErrors = Object.assign({}, this.defaultFormErrors)

      // Set the form values to the values of the selected item
      this.editedItem = Object.assign({}, this.defaultItem)

      // Reset index of item to edit
      this.editedIndex = -1

      // Show edit dialog
      this.dialogEdit.open()
      setTimeout(() => {
        var elems3 = document.querySelectorAll('select')
        // eslint-disable-next-line
        var instances3 = M.FormSelect.init(elems3, {
          dropdownOptions: {
            coverTrigger: false
          }
        })

        // eslint-disable-next-line
        M.updateTextFields()
      }, 100)
    },

    // Setup the edit form with values from the clicked row
    openEditDialog (item) {
      // Set default formErrors
      this.formErrors = Object.assign({}, this.defaultFormErrors)

      // Get the row index
      this.editedIndex = this.addressList.indexOf(item)

      // Set the form values to the values of the selected item
      this.editedItem = Object.assign({}, item)

      // Show edit dialog
      this.dialogEdit.open()
      setTimeout(() => {
        var elems2 = document.querySelectorAll('.datepicker')
        // eslint-disable-next-line
        var maxDate = new Date()
        // eslint-disable-next-line
        var instances2 = M.Datepicker.init(elems2, {
          // Datepicker within a modal looks wrong, if not placed on body
          container: 'body',
          format: 'dd mmm yyyy',
          defaultDate: parse(item.rawDateOfBirth),
          setDefaultDate: true,
          maxDate: maxDate,
          // 25+ year olds are not kids, right?
          yearRange: [(maxDate.getFullYear() - 25), maxDate.getFullYear()]
        })

        var elems3 = document.querySelectorAll('select')
        // eslint-disable-next-line
        var instances3 = M.FormSelect.init(elems3, {
          dropdownOptions: {
            coverTrigger: false
          }
        })

        // eslint-disable-next-line
        M.updateTextFields()
      }, 100)
    },

    // Reset the edit variables and close dialog
    closeDialogEdit () {
      setTimeout(() => {
        // Set default formErrors
        this.formErrors = Object.assign({}, this.defaultFormErrors)
        // Set default form fields
        this.editedItem = Object.assign({}, this.defaultItem)
        // Reset index of item to edit
        this.editedIndex = -1
      }, 300)
      this.dialogEdit.close()
    },

    // Delete an item
    deleteItem (item) {
      let index = this.addressList.indexOf(item)
      let dataBody = {
        addressID: this.addressList[index].id
      }

      if (confirm('Are you sure you want to delete this address?')) {
        // Save to API
        httpApi.callWithToken({
          url: 'address',
          data: dataBody,
          method: 'delete'
        })
          .then((resp) => {
            // Show success message
            this.$store.dispatch('SHOW_STATUS_MESSAGE', {
              color: 'success',
              message: resp.message
            })

            // Delete item from main list
            this.addressList.splice(index, 1)
          })
          .catch((err) => {
            // Show error message
            this.$store.dispatch('SHOW_STATUS_MESSAGE', {
              color: 'error',
              message: err.message
            })
          })
      }
    },

    // Update default shipping address
    updateShippingDefault (item) {
      let dataBody = {
        addressID: item.id,
        updateType: 'DEFAULT_SHIPPING'
      }

      // Save to API
      httpApi.callWithToken({
        url: 'address',
        data: dataBody,
        method: 'put'
      })
        .then((resp) => {
          // Uncheck all other address' shipping default
          this.addressList.forEach((address, key) => {
            if (address.id === item.id) {
              address.ship_default = '1'
            } else {
              address.ship_default = '0'
            }
          })

          // Show success message
          this.$store.dispatch('SHOW_STATUS_MESSAGE', {
            color: 'success',
            message: resp.message
          })
        })
        .catch((err) => {
          // There could be multiple errors in an array. Convert to a string
          let errorString = Object.values(err.data)
          errorString = errorString.join(', ')

          // Show error message
          this.$store.dispatch('SHOW_STATUS_MESSAGE', {
            color: 'error',
            message: errorString
          })
        })
    }
  }
}
</script>
